var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [[_c("el-form", {
    ref: "form",
    attrs: {
      model: _vm.formData,
      "label-width": "80px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "充值申请ID:",
      "label-width": "150px"
    }
  }, [_vm._v(" " + _vm._s(_vm.formData.id) + " ")]), _c("el-form-item", {
    attrs: {
      label: "申请原因:",
      "label-width": "150px"
    }
  }, [_vm._v(" " + _vm._s(_vm.formData.reason) + " ")]), _c("el-form-item", {
    staticStyle: {
      color: "#409EFF"
    },
    attrs: {
      label: "充值项信息:",
      "label-width": "150px"
    }
  }, _vm._l(_vm.formData.pay_item_id.split(","), function (itemId) {
    return _c("div", {
      key: itemId
    }, [_vm._v(" ID: "), _c("span", {
      staticStyle: {
        color: "#67c23a",
        "margin-right": "10px"
      }
    }, [_vm._v(" " + _vm._s(itemId) + " ")]), _vm._v(" 名称："), _c("span", {
      staticStyle: {
        color: "#67c23a"
      }
    }, [_vm._v(_vm._s(_vm.PayInfoList[itemId]))])]);
  }), 0), _c("el-form-item", {
    attrs: {
      label: "充值配置信息:",
      "label-width": "150px"
    }
  }, [_c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.formData.role_list,
      "header-row-style": _vm.headStyle,
      "row-style": _vm.rowStyle
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "server_id",
      label: "服务器ID",
      "min-width": "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "name",
      label: "服务器名",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm.serverMap[scope.row.server_id]) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "role_id",
      label: "角色ID",
      "min-width": "150"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "role_name",
      label: "角色名称",
      "min-width": "150"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "role_id",
      label: "发放状态",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(_vm.itemStatus[scope.row.status]) + " ")];
      }
    }])
  })], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "申请人:",
      "label-width": "150px"
    }
  }, [_vm._v(" " + _vm._s(_vm.UserMap[_vm.formData.apply_id]) + " ")]), _c("el-form-item", {
    attrs: {
      label: "申请日期:",
      "label-width": "150px"
    }
  }, [_vm._v(" " + _vm._s(_vm.formData.apply_date) + " ")]), _c("el-form-item", {
    attrs: {
      label: "审批人:",
      "label-width": "150px"
    }
  }, [_vm._v(" " + _vm._s(_vm.formData.approve_state == 1 ? "—" : _vm.UserMap[_vm.formData.approve_id]) + " ")]), _c("el-form-item", {
    attrs: {
      label: "审批日期:",
      "label-width": "150px"
    }
  }, [_vm._v(" " + _vm._s(_vm.formData.approve_state == 1 ? "—" : _vm.formData.approve_date) + " ")]), _c("el-form-item", {
    attrs: {
      label: "审批理由:",
      "label-width": "150px"
    }
  }, [_vm._v(" " + _vm._s(_vm.formData.approve_state == 1 ? "—" : _vm.formData.approve_reason) + " ")])], 1)]], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };